import { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 1800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const InsertLineModal = ({ open, setOpen, handleNewLineAdd }) => {
  const [formData, setFormData] = useState({
    originalText: '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    formData.originalText && handleNewLineAdd(formData);
    setOpen(false);
    setFormData({
      ...formData,
      originalText: ''
    })
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Enter orignal Text
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Original Text"
            name="originalText"
            value={formData.originalText}
            onChange={handleChange}
            multiline
            minRows={1}
            fullWidth
          />

          <Stack direction="row" justifyContent="flex-end" gap={1}>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit}>
              Save
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default InsertLineModal;
